// extracted by mini-css-extract-plugin
export var drawerPaper = "_18-0";
export var itemCard = "_18-1";
export var itemImage = "_18-2";